<template>
  <layout-main-inner title="首页设置">
    <div slot="action">
      <el-button
        v-if="$route.query.portalPageId"
        type="primary"
        :loading="loading"
        @click="edit">更新</el-button>
      <el-button
        v-else
        type="primary"
        :loading="loading"
        @click="edit">保存</el-button>
    </div>
    <layout-card-wrap v-loading="loading">
      <div class="page-wrap">
        <div class="weapp-phone">
          <!-- app navibar -->
          <div
            class="series-item-wrap"
            :class="{ active: headers.visible }"
            @click="
              () => {
                toggle('headers');
              }
            "
          >
            <we-header-view :templateId="1" />
          </div>
          <div
            style="background-color:#000;height: 560px;overflow-y: scroll;overflow-x:hidden;"
          >
            <draggable
              v-if="seriesList.length"
              v-model="seriesList"
              :options="dragOptions"
            >
              <template v-for="(item, index) in seriesList">
                <div
                  :key="index"
                  style="cursor: grab;"
                  class="series-item-wrap"
                  :class="{ active: item.visible }"
                  @click="
                    () => {
                      toggle(undefined, index);
                    }
                  "
                >
                  <we-series-view
                    v-if="item.componentName === 'exchangeshow'"
                    :series="item"
                    :button="headers.orderButtonImage"
                    :colourStyle="headers.colourStyle"
                  />
                  <we-circular-view
                    v-if="
                      item.componentName === 'pictureadv' &&
                        item.layoutType === 0
                    "
                    :list="item.graphics"
                  />
                  <we-image-view
                    v-if="
                      item.componentName === 'pictureadv' &&
                        item.layoutType !== 0
                    "
                    :imageView="item"
                    :templateId="1"
                  />
                </div>
              </template>
            </draggable>
          </div>
          <!-- app tab-bar -->
          <div
            class="series-item-wrap"
            :class="{ active: tabBar.visible }"
            @click="
              () => {
                toggle('tabBar');
              }
            "
          >
            <we-footer-view
              :templateId="headers.footStyle"
              :tabbar="tabBar"
            />
          </div>
          <el-button
            type="primary"
            style="margin:50px 0 10px 5px"
            @click="addSeries(1)">商品</el-button>
          <el-button
            type="primary"
            style="margin:50px 0 10px 5px"
            @click="addSeries(2)">图片导航</el-button>
          <el-button
            type="primary"
            style="margin:50px 0 10px 5px"
            @click="addSeries(3)">轮播图</el-button>
        </div>
        <div class="setting-wrap">
          <we-header
            v-show="headers.visible"
            ref="header"
            v-model="headers" />
          <template v-for="(item, index) in seriesList">
            <template
              v-if="item.componentName === 'pictureadv' && item.layoutType === 0 ">
              <we-circular
                v-show="item.visible"
                :ref="'series_' + index"
                :key="index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem"
              />
            </template>
            <template v-if="item.componentName === 'exchangeshow'">
              <we-series
                v-show="item.visible"
                :key="index"
                :ref="'series_' + index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem"
              />
            </template>
            <template
              v-if=" item.componentName === 'pictureadv' && item.layoutType !== 0">
              <we-image
                v-show="item.visible"
                :ref="'series_' + index"
                :key="index"
                v-model="seriesList[index]"
                :index="index"
                @deleteItem="deleteItem"
              />
            </template>
          </template>
          <we-footer
            v-show="tabBar.visible"
            ref="footer"
            v-model="tabBar" />
        </div>
      </div>
    </layout-card-wrap>
    <!-- <template
      v-if="$route.query.type === 'detail'"
      slot="footer">
      <button-back ref="back" />
      <el-button
        type="primary"
        :loading="loading"
        @click="update">编辑</el-button>
    </template>
    <template
      v-else
      slot="footer">
      <el-checkbox
        v-model="headers.status"
        style="margin-right:10px"
        :true-label="1"
        :false-label="0">立即发布</el-checkbox>
      <button-back ref="back" />
      <el-button
        v-if="$route.query.portalPageId"
        type="primary"
        :loading="loading"
        @click="edit">更新</el-button>
      <el-button
        v-else
        type="primary"
        :loading="loading"
        @click="edit">保存</el-button>
    </template> -->
  </layout-main-inner>
</template>

<script>
import './busi/index.styl'
import WeHeader from './busi/we-header.vue'
import WeHeaderView from './busi/we-header-view.vue'

import WeCircular from './busi/we-circular.vue'
import WeCircularView from './busi/we-circular-view.vue'

import WeImage from './busi/we-image.vue'
import WeImageView from './busi/we-image-view.vue'
// import WeActivity from './busi/we-activity.vue'
// import WeActivityView from './busi/we-activity-view.vue'

// import WeDiscount from './busi/we-discount.vue'
// import WeDiscountView from './busi/we-discount-view.vue'

import WeSeries from './busi/we-series.vue'
import WeSeriesView from './busi/we-series-view.vue'

import WeFooterView from './busi/we-footer-view.vue'

import draggable from 'vuedraggable'
import WeFooter from './busi/we-footer.vue'

export default {
  name: 'GatewayEdit', // WeHeader, WeCircular, WeActivity,WeDiscount, WeSeries,WeActivityView, WeDiscountView,
  components: {
    WeCircularView,
    WeHeaderView,
    WeSeriesView,
    WeFooterView,
    WeImageView,
    WeImage,
    WeHeader,
    WeCircular,
    WeSeries,
    WeFooter,
    draggable
  },
  props: {},
  data() {
    return {
      loading: false,
      dragOptions: {
        animation: 0,
        disabled: false,
        group: 'description',
        ghostClass: 'ghost'
      },
      headers: {
        visible: false,
        pageName: '',
        pageTitle: '',
        status: 0,
        orderButtonImage: [],
        // footStyle: 1,
        // tabBar: [0, 1, 2, 3],
        colourStyle: [
          { elementType: 'price', colour: '#FF0000' },
          { elementType: 'button', colour: '#1989fa' },
          { elementType: 'header', colour: '#07c160' }
        ]
      },
      tabBar: {
        tabBarNameCheckedColour: null,
        tabBarNameUncheckedColour: null,
        tabBarCustoms: [
          {
            tabBarId: 0,
            tabBarName: '首页',
            checkedImage: [],
            uncheckedImage: []
          },
          {
            tabBarId: 1,
            tabBarName: '商城',
            checkedImage: [],
            uncheckedImage: []
          },
          {
            tabBarId: 2,
            tabBarName: '购物车',
            checkedImage: [],
            uncheckedImage: []
          },
          {
            tabBarId: 3,
            tabBarName: '我的',
            checkedImage: [],
            uncheckedImage: []
          }
        ],
        visible: false
      },
      seriesList: [
        // {
        //   componentName: 'pictureadv',
        //   layoutType: 0,
        //   graphics: [],
        //   visible: false
        // }, // 轮播图
        // {
        //   componentName: 'pictureadv',
        //   layoutType: 1,
        //   graphics: [],
        //   visible: false
        // }, // 多图链接
        // {
        //   componentName: 'exchangeshow',
        //   exchangeGoodsList: [],
        //   layoutType: 2,
        //   visible: false
        // } // 商品区块
      ]
    }
  },
  mounted() {
    console.log(this.$route.query)
    this.vendorId = this.$route.query.vendorId
    if (this.$route.query.portalPageId) {
      this.portalPageId = this.$route.query.portalPageId
      this.getportalpage()
    }
    //  else {
    //   this.seriesList.push({
    //     componentName: 'exchangeshow',
    //     exchangeGoodsList: [],
    //     layoutType: 3,
    //     visible: false
    //   })
    //   this.toggle('headers')
    // }
    this.toggle('headers')
  },
  methods: {
    deleteItem(index) {
      this.seriesList.splice(index, 1)
    },
    update() {
      this.$router.push(
        `/gatewayedit?portalPageId=${this.portalPageId}&vendorId=${this.vendorId}&isHomepage=${this.$route.query.isHomepage}`
      )
    },
    toggle(ref, index) {
      if (index !== undefined) {
        this.headers.visible = false
        this.tabBar.visible = false
        this.seriesList.forEach((i, idx) => {
          i.visible = idx === index
        })
      } else {
        this.headers.visible = false
        this.tabBar.visible = false
        this.seriesList.forEach(i => {
          i.visible = false
        })
        this[ref].visible = true
      }
    },
    addSeries(type) {
      if (type === 1) {
        this.seriesList.push({
          componentName: 'exchangeshow',
          exchangeGoodsList: [],
          layoutType: 2,
          visible: false
        })
      }
      if (type === 3) {
        this.seriesList.push({
          componentName: 'pictureadv',
          layoutType: 0,
          graphics: [],
          visible: false
        })
      }
      if (type === 2) {
        this.seriesList.push({
          componentName: 'pictureadv',
          layoutType: 1,
          graphics: [],
          visible: false
        })
      }
    },
    edit() {
      console.log(this.$refs)
      const submitList = [this.$refs.header.submit()]
      this.seriesList.forEach((i, idx) => {
        const ref = 'series_' + idx
        console.log(ref, this.$refs[ref][0], this.$refs[ref][0].submit)
        submitList.push(this.$refs[ref][0].submit())
      })
      submitList.push(this.$refs.footer.submit())
      Promise.all(submitList)
        .then(() => {
          const list = this.seriesList.map(i => {
            if (i.componentName === 'pictureadv') {
              return {
                componentName: 'pictureadv',
                data: {
                  layoutType: i.layoutType,
                  graphics: i.graphics.map(s => {
                    return {
                      ...s,
                      image: s.image.map(img => img.url).join(',')
                    }
                  })
                }
              }
            }
            if (i.componentName === 'exchangeshow') {
              return {
                componentName: i.componentName,
                // layoutType: i.layoutType,
                data: {
                  layoutType: i.layoutType,
                  // style: i.style,
                  exchangeGoodsList: i.exchangeGoodsList.map(s => ({
                    exchangeGoodsId: s.exchangeGoodsId
                  }))
                }
              }
            }
            return {}
          })
          const headers = this.headers
          const tabBar = this.tabBar
          const postData = {
            pageName: headers.pageName,
            pageTitle: headers.pageTitle,
            status: headers.status,
            orderButtonImage: headers.orderButtonImage.map(img => img.url).join(','),
            colourStyle: JSON.stringify(this.headers.colourStyle),
            tabBarCustom: {
              tabBarNameCheckedColour: tabBar.tabBarNameCheckedColour,
              tabBarNameUncheckedColour: tabBar.tabBarNameUncheckedColour,
              tabBarCustoms: tabBar.tabBarCustoms.map(i => {
                return {
                  ...i,
                  checkedImage: i.checkedImage.map(img => img.url).join(','),
                  uncheckedImage: i.uncheckedImage.map(img => img.url).join(',')
                }
              })
            },
            portalPageId: this.portalPageId || null,
            wxappPageId: this.wxappPageId || null,
            vendorId: this.vendorId,
            vBody: [
              // {
              //   componentName: this.pictureadv.componentName,
              //   data: {
              //     graphics: this.pictureadv.graphics.map(i => ({
              //       link: i.msgId,
              //       linkType: 0
              //     }))
              //   },
              //   elementId: this.pictureadv.elementId || null
              // },
              // {
              //   componentName: this.pointstask.componentName,
              //   data: {
              //     pointsRuleList: this.pointstask.pointsRuleList.map(i => ({
              //       ruleType: i
              //     })),
              //     style: this.pointstask.style
              //   },
              //   elementId: this.pointstask.elementId || null
              // },
              // {
              //   componentName: this.discount.componentName,
              //   data: {
              //     title: this.discount.title,
              //     subtitle: this.discount.subTitle,
              //     exchangeGoodsList: this.discount.exchangeGoodsList.map(i => ({
              //       exchangeGoodsId: i.goodsId
              //     })),
              //     layoutType: this.discount.layoutType,
              //     style: this.discount.style,
              //     groupId: 1,
              //     layout: null
              //   },
              //   elementId: this.discount.elementId || null
              // },
              ...list
            ]
          }
          console.log(postData)
          this.loading = true
          const dispatch = this.portalPageId
            ? 'updateportalpage'
            : 'addportalpage'
          this.$store.dispatch(`gateway/${dispatch}`, {
            payload: {
              ...postData
            },
            success: () => {
              this.loading = false
              this.$message.success('更新成功')
              // this.$router.go(-1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
        .catch(err => {
          const error = JSON.parse(err.message)
          console.log(error)
          console.dir(JSON.parse(err.message))
          if (error.pop) {
            this.toggle(error.pop)
          }
          if (Number.isInteger(error.index)) {
            this.toggle(undefined, error.index)
          }
        })
    },
    getportalpage() {
      this.loading = true
      this.$store.dispatch('gateway/getportalpage', {
        payload: {
          vendorId: this.vendorId,
          portalPageId: this.portalPageId
        },
        success: res => {
          this.loading = false
          const data = res.data
          this.wxappPageId = data.wxappPageId
          this.headers = {
            ...this.headers,
            pageName: data.pageName,
            pageTitle: data.pageTitle,
            status: data.status,
            orderButtonImage: data.orderButtonImage ? data.orderButtonImage.split(',').map(url => ({ url })) : [],
            colourStyle: JSON.parse(data.colourStyle) || [
              { elementType: 'price', colour: '#FF0000' },
              { elementType: 'button', colour: '#1989fa' },
              { elementType: 'header', colour: '#07c160' }
            ]
          }
          this.tabBar = {
            ...this.tabBar,
            tabBarNameCheckedColour: data.tabBarCustom.tabBarNameCheckedColour,
            tabBarNameUncheckedColour: data.tabBarCustom.tabBarNameUncheckedColour,
            tabBarCustoms: data.tabBarCustom.tabBarCustoms ? data.tabBarCustom.tabBarCustoms.map(i => {
              return {
                ...i,
                checkedImage: i.checkedImage ? i.checkedImage.split(',').map(url => ({ url })) : [],
                uncheckedImage: i.uncheckedImage ? i.uncheckedImage.split(',').map(url => ({ url })) : []
              }
            }) : [{
              tabBarId: 0,
              tabBarName: '首页',
              checkedImage: [],
              uncheckedImage: []
            },
            {
              tabBarId: 1,
              tabBarName: '商城',
              checkedImage: [],
              uncheckedImage: []
            },
            {
              tabBarId: 2,
              tabBarName: '购物车',
              checkedImage: [],
              uncheckedImage: []
            },
            {
              tabBarId: 3,
              tabBarName: '我的',
              checkedImage: [],
              uncheckedImage: []
            }]
          }
          const list = data.vBody.map(i => {
            if (i.componentName === 'pictureadv') {
              return {
                visible: false,
                componentName: 'pictureadv',
                layoutType: i.data.layoutType,
                graphics: i.data.graphics.map(s => {
                  return {
                    ...s,
                    image: s.image ? s.image.split(',').map(url => ({ url })) : []
                  }
                })
              }
            }
            if (i.componentName === 'exchangeshow') {
              return {
                visible: false,
                componentName: i.componentName,
                layoutType: i.data.layoutType,
                exchangeGoodsList: i.data.exchangeGoodsList.map(s => ({
                  ...s,
                  image: s.goodsSmallImage ? s.goodsSmallImage.split(',')[0] : '',
                  title: s.goodsName
                }))
              }
            }
            return {}
          })
          this.seriesList.push(...list)
          // data.vBody.forEach(i => {
          //   if (i.componentName === 'pictureadv') {
          //     this.pictureadv = {
          //       componentName: 'pictureadv',
          //       graphics: i.data.graphics.map(s => {
          //         return {
          //           ...s,
          //           msgId: +s.link,
          //           remark: s.name
          //         }
          //       }),
          //       elementId: i.elementId
          //     }
          //   }
          //   if (i.componentName === 'pointstask') {
          //     this.pointstask = {
          //       componentName: 'pointstask',
          //       pointsRuleList: i.data.pointsRuleList.map(s => s.ruleType),
          //       style: i.data.style,
          //       elementId: i.elementId
          //     }
          //   }
          //   if (i.componentName === 'exchangeshow') {
          //     if (i.data.groupId === 1) {
          //       this.discount = {
          //         componentName: 'exchangeshow',
          //         title: i.data.title,
          //         subTitle: i.data.subtitle,
          //         // exchangeGoodsList: [],
          //         exchangeGoodsList: i.data.exchangeGoodsList.map(s => {
          //           return {
          //             ...s,
          //             goodsId: s.exchangeGoodsId,
          //             image: s.goodsSmallImage,
          //             title: s.goodsName,
          //             remark: s.goodsDesc
          //           }
          //         }),
          //         style: i.data.style,
          //         layoutType: i.data.layoutType,
          //         elementId: i.elementId
          //       }
          //     } else {
          //       this.seriesList.push({
          //         componentName: 'exchangeshow',
          //         title: i.data.title,
          //         subTitle: i.data.subtitle,
          //         style: i.data.style,
          //         exchangeGoodsList: i.data.exchangeGoodsList.map(s => {
          //           return {
          //             ...s,
          //             image: s.goodsSmallImage,
          //             title: s.goodsName,
          //             remark: s.goodsDesc
          //           }
          //         }),
          //         layoutType: i.data.layoutType,
          //         layout: i.data.layout.map(s => {
          //           if (s.propertyType === 'graphic') {
          //             return {
          //               ...s.data,
          //               ...s,
          //               msgId: +s.link
          //             }
          //           } else {
          //             return s
          //           }
          //         }),
          //         visible: false
          //       })
          //     }
          //   }
          // })
          // this.inited = true
          setTimeout(() => {
            this.toggle('headers')
          }, 20)
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
.page-wrap {
  display: flex;
}

.setting-wrap {
  flex: 1;
  padding-left: 24px;
}

.weapp-phone {
  flex: 0 0 375px;
  width: 375px;
  border: 1px solid #f0f2f5;

  img {
    width: 100%;
    display: inline-block;
    vertical-align: top;
  }

  .active {
    position: relative;

    &::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      top: -50%;
      right: -50%;
      bottom: -50%;
      left: -50%;
      border: 2px dashed red;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
    }
  }

  .series-item-wrap {
    position: relative;
  }

  .series-item-wrap + .series-item-wrap {
    margin-top: 5px;
  }
}
</style>
